import { useEffect, useState } from 'react'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { addDays, differenceInCalendarDays } from 'date-fns'
import { useTranslation } from 'react-i18next'

const CANCEL_DAYS_AFTER_PAST_DUE = 21

export const useCanceledAccountNotification = () => {
  const { t } = useTranslation('general')
  const { data } = useGetPlansDetails()
  const [cancelledMessage, setCancelledMessage] = useState<string>('')

  useEffect(() => {
    const { status, trial, cancellationDate, currentPeriodStart, cancelled } = data || {}
    const isPastDue = status === 'past_due' && currentPeriodStart

    if (cancelled || isPastDue) {
      const isTrailActive = trial?.active
      const endDate = cancelled
        ? isTrailActive
          ? trial.endTime
          : cancellationDate
        : addDays(new Date(currentPeriodStart as string), CANCEL_DAYS_AFTER_PAST_DUE)
      const dateFormatted = endDate ? differenceInCalendarDays(new Date(endDate), new Date()) : 0

      setCancelledMessage(
        t(`system_messages.canceled_account${isTrailActive ? '_trial' : ''}`, {
          days: dateFormatted,
        })
      )
    } else {
      setCancelledMessage('')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.status, data?.trial, data?.currentPeriodEnd, data?.cancelled])

  return { cancelledMessage }
}
